import { goToStep, loadAuthState } from "../auth";
import { isCaptchaError, mountCaptcha } from "../captcha";
import { nextStep } from "../routes";
import { supabase } from "../supabase";
import { t } from "../strings/en";
import { applyStrings, byId, setBusy, setMessage, showPanel } from "../ui";

applyStrings();

const form = byId<HTMLFormElement>("form");
const email = byId<HTMLInputElement>("email");
const password = byId<HTMLInputElement>("password");
const submit = byId<HTMLButtonElement>("submit");
const message = byId("message");
const captcha = mountCaptcha(byId("captcha"));
const codeForm = byId<HTMLFormElement>("codeForm");
const code = byId<HTMLInputElement>("code");
const codeSubmit = byId<HTMLButtonElement>("codeSubmit");
const codeMessage = byId("codeMessage");

// Sem sessão: pede e-mail e senha. Com sessão aal1 e fator verificado: pede o código.
// Qualquer outro estado segue o fluxo normal.
async function route(): Promise<void> {
  const step = nextStep(await loadAuthState());
  if (step === "login") showPanel("panel-form");
  else if (step === "mfa-challenge") showPanel("panel-code");
  else goToStep(step);
}

form.addEventListener("submit", async (e) => {
  e.preventDefault();
  setMessage(message, null);
  const blocked = captcha.blocker();
  if (blocked) return setMessage(message, blocked);
  setBusy(submit, true);
  try {
    const { error } = await supabase.auth.signInWithPassword({
      email: email.value.trim(),
      password: password.value,
      options: { captchaToken: captcha.token() },
    });
    if (error) {
      if (isCaptchaError(error)) setMessage(message, t("captchaFailed"));
      else if (error.code === "email_not_confirmed") setMessage(message, t("loginEmailNotConfirmed"));
      else if (error.code === "invalid_credentials") setMessage(message, t("loginInvalid"));
      else if (error.status === 429) setMessage(message, t("authTooMany"));
      else setMessage(message, t("genericError"));
      return;
    }
    password.value = "";
    await route();
  } catch {
    setMessage(message, t("networkError"));
  } finally {
    // O token é de uso único: o próximo envio precisa de outro.
    captcha.reset();
    setBusy(submit, false);
  }
});

codeForm.addEventListener("submit", async (e) => {
  e.preventDefault();
  setMessage(codeMessage, null);
  setBusy(codeSubmit, true);
  try {
    const { error } = await supabase.functions.invoke("recovery-codes", {
      body: { action: "redeem", code: code.value.trim() },
    });
    if (error) {
      const status = (error as { context?: Response }).context?.status;
      if (status === 429) setMessage(codeMessage, t("recoverTooMany"));
      else if (status === 400) setMessage(codeMessage, t("recoverInvalid"));
      else setMessage(codeMessage, t("genericError"));
      return;
    }
    // O servidor removeu o fator antigo: renova a sessão e leva ao autenticador novo.
    await supabase.auth.refreshSession();
    goToStep(nextStep(await loadAuthState()));
  } catch {
    setMessage(codeMessage, t("networkError"));
  } finally {
    setBusy(codeSubmit, false);
  }
});

void route().catch(() => {
  showPanel("panel-form");
  setMessage(message, t("networkError"));
});
